import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container site-footer-inner">
        <span className="site-footer-logo">
          <i className="fas fa-microscope" aria-hidden="true"></i> Medcodes
        </span>
        <span className="site-footer-copy">&copy; {year} Medcodes</span>
        <nav className="site-footer-nav" aria-label="Liens du pied de page">
          <Link to="/about">À propos</Link>
          <Link to="/contact">Nous joindre</Link>
          <Link to="/privacy">Politique de confidentialité</Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
